import React, { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { UserEventCard } from '../../../components/Dashboard/UserEventCard'
import { reservationService } from '../../../services/reservation.service'
import { eventService } from '../../../services/event.service'

export const AccountEventDetails = () => {
  const [reservations, setReservations] = useState({ amount: 0 })
  const [event, setEvent] = useState([])
  const { idEvento } = useParams()
  useEffect(() => {
    const getTicketsReservation = async () => {
      try {
        const reservaciones = await reservationService.getTicketsReservation(idEvento)
        const eventos = await eventService.getOneEvent(idEvento)
        setReservations({ amount: reservaciones.amount })
        setEvent(eventos)
      } catch (error) {
        console.log(error)
      }
    }
    getTicketsReservation()
  }, [])
  return (
    <>
      {/* Account collections */}
      <div className="pb-5 mb-lg-2 mt-md-0">
        <div className="ps-md-3 ps-lg-0 mt-md-2 pt-md-4 pb-md-2">
          <div className="d-sm-flex align-items-center justify-content-between pt-xl-1 mb-3 pb-3">
            <h1 className="h2 mb-sm-0">Detalles del Evento</h1>
          </div>
            <div>
                {
                    <UserEventCard
                    type="reservacion"
                    key={reservations.id_evento}
                    reservation = {reservations}
                    evento = {event} />
                }
            </div>
          </div>
        </div>
    </>
  )
}
